import apiClient from './apiClient';

class BannerClient {
    // 取得 banner 背景
    getBanner = (locale, bannerCode) =>
        apiClient.get(`/ad/banners/${bannerCode}`, {
            headers: {
                'X-LANG': 'zh-' + locale,
            },
        });

    // 取得 搜尋關鍵字
    getSearchOptions = (locale) =>
        apiClient.get('/home/search-option?site=18', {
            headers: {
                'X-LANG': 'zh-' + locale,
            },
        });

    // 取得閒置彈窗內容
    getIdle = (locale) =>
        apiClient.get('/home/idle', {
            headers: {
                'X-LANG': 'zh-' + locale,
            },
        });
}

const bannerClient = new BannerClient();

export default bannerClient;
